import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "../Styles/PrivacyPolicy.css";

export default function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | VE Abroad - Education & Migration</title>
        <meta name="description" content="Read our Privacy Policy to understand how Vidya Education Abroad collects, uses, and safeguards your personal data when you interact with our website." />
        <link rel="canonical" href="https://veabroad.com/privacy" />
      </Helmet>

      <section className="privacy-hero">
        <h1>Privacy Policy</h1>
        <p>Last updated: January 1, 2026</p>
      </section>

      <div className="privacy-container container">

        <div className="privacy-intro">
          <p>
            Vidya Education Abroad ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website <strong>veabroad.com</strong> or submit any inquiry or consultation form.
          </p>
          <p>
            Please read this policy carefully. If you disagree with its terms, please discontinue use of the site.
          </p>
        </div>

        <div className="privacy-section">
          <h2>1. Information We Collect</h2>
          <p>We collect information you voluntarily provide when you fill out any form on our website, including:</p>
          <ul>
            <li><strong>Full Name</strong></li>
            <li><strong>Email Address</strong></li>
            <li><strong>Phone Number</strong></li>
            <li><strong>Service of Interest</strong> (e.g. Immigration, Study Abroad, Visa Services)</li>
            <li><strong>Country of Interest</strong></li>
            <li><strong>Inquiry Type and Description</strong> (for consultation forms)</li>
          </ul>
          <p>We may also automatically collect certain technical data when you visit our website, such as your IP address, browser type, device type, and pages visited — through standard web server logs or analytics tools.</p>
        </div>

        <div className="privacy-section">
          <h2>2. How We Use Your Information</h2>
          <p>The information we collect is used to:</p>
          <ul>
            <li>Respond to your inquiries and consultation requests</li>
            <li>Provide immigration, study abroad, and visa guidance services</li>
            <li>Send you relevant updates, newsletters, or promotional content (only if you have opted in)</li>
            <li>Improve our website and services based on usage patterns</li>
            <li>Comply with legal obligations</li>
          </ul>
          <p>We do <strong>not</strong> sell, rent, or trade your personal information to third parties for marketing purposes.</p>
        </div>

        <div className="privacy-section">
          <h2>3. How We Store Your Information</h2>
          <p>
            All form submissions are securely stored in our database. We implement appropriate technical and organizational measures to protect your data against unauthorized access, alteration, disclosure, or destruction.
          </p>
          <p>
            Your data is retained for as long as necessary to fulfill the purposes outlined in this policy, or as required by applicable law.
          </p>
        </div>

        <div className="privacy-section">
          <h2>4. Sharing Your Information</h2>
          <p>We may share your information only in the following limited circumstances:</p>
          <ul>
            <li><strong>Service Providers:</strong> Trusted third-party vendors who assist us in operating our website or conducting our business (e.g. email services, hosting providers), subject to confidentiality agreements.</li>
            <li><strong>Legal Requirements:</strong> If required by law, court order, or government authority.</li>
            <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your data may be transferred as part of that transaction.</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>5. Cookies</h2>
          <p>
            Our website may use cookies to enhance your browsing experience. Cookies are small files stored on your device that help us understand how you use our site. You can choose to disable cookies through your browser settings, though this may affect some functionality of the website.
          </p>
        </div>

        <div className="privacy-section">
          <h2>6. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites (e.g. government immigration portals, university websites). We are not responsible for the privacy practices or content of those sites. We encourage you to review their privacy policies before providing any personal information.
          </p>
        </div>

        <div className="privacy-section">
          <h2>7. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Request access to the personal data we hold about you</li>
            <li>Request correction of inaccurate or incomplete data</li>
            <li>Request deletion of your personal data</li>
            <li>Withdraw consent for marketing communications at any time</li>
          </ul>
          <p>
            To exercise any of these rights, please contact us at <strong>info@veabroad.com</strong>.
          </p>
        </div>

        <div className="privacy-section">
          <h2>8. Children's Privacy</h2>
          <p>
            Our services are not directed to individuals under the age of 16. We do not knowingly collect personal information from children. If you believe we have inadvertently collected such information, please contact us immediately and we will delete it.
          </p>
        </div>

        <div className="privacy-section">
          <h2>9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated "Last updated" date. We encourage you to review this page periodically.
          </p>
        </div>

        <div className="privacy-section">
          <h2>10. Contact Us</h2>
          <p>If you have any questions or concerns about this Privacy Policy, please contact us:</p>
          <ul>
            <li><strong>Email:</strong> info@veabroad.com</li>
            <li><strong>Phone:</strong> +91 8850285886</li>
            <li><strong>Address:</strong> Amar Jyoti CHS, Andheri West, Mumbai, Maharashtra, India</li>
          </ul>
        </div>

        <div className="privacy-cta">
          <p>Have questions about your data? We're happy to help.</p>
          <Link to="/consultationForm" className="lmbtn">Contact Us</Link>
        </div>

      </div>
    </>
  );
}
